// Tiered configuration for location-based landing pages.
// - Tier 1: all cities in the countries listed in TIER_ONE_COUNTRIES.
// - Tier 2: specific cities in other countries defined in TIER_TWO_CITIES.

// ISO country codes for tier 1 countries
export const TIER_ONE_COUNTRIES = [
  'US', // United States
  'GB', // United Kingdom
  'CA', // Canada
  'AU', // Australia
  'AE', // United Arab Emirates
  'DE', // Germany
  'IE', // Ireland
  'NL', // Netherlands
];

// Tier 2 cities by ISO country code and city slug
export const TIER_TWO_CITIES = {
  IN: [
    'bengaluru',
    'hyderabad',
    'mumbai',
    'pune',
    'chennai',
    'delhi',
    'kolkata',
    'ahmedabad',
    'gurugram',
    'jaipur',
    'surat',
  ],
  ES: [
    'madrid',
    'barcelona',
    'valencia',
    'sevilla',
    'malaga',
    'zaragoza',
    'murcia',
    'palma',
    'bilbao',
    'alicante',
  ],
  FR: [
    'paris',
    'lyon',
    'marseille',
    'toulouse',
    'bordeaux',
    'nice',
    'nantes',
    'lille',
    'strasbourg',
    'montpellier',
  ],
  IT: [
    'rome',
    'milan',
    'naples',
    'turin',
    'palermo',
    'genoa',
    'bologna',
    'florence',
    'bari',
    'catania',
  ],
  SE: [
    'stockholm',
    'gothenburg',
    'malmo',
    'uppsala',
    'vasteras',
    'linkoping',
    'orebro',
    'helsingborg',
    'jonkoping',
    'norrkoping',
  ],
  CH: [
    'zurich',
    'geneva',
    'basel',
    'lausanne',
    'bern',
    'winterthur',
    'lucerne',
    'st-gallen',
    'lugano',
    'biel',
  ],
  PT: [
    'lisbon',
    'porto',
    'braga',
    'coimbra',
    'funchal',
    'aveiro',
    'faro',
    'setubal',
    'cascais',
    'vila-nova-de-gaia',
  ],
  NZ: [
    'auckland',
    'wellington',
    'christchurch',
    'hamilton',
    'tauranga',
    'dunedin',
    'napier',
    'nelson',
    'queenstown',
    'rotorua',
  ],
  JP: [
    'tokyo',
    'osaka',
    'yokohama',
    'nagoya',
    'kyoto',
    'fukuoka',
    'kawasaki',
    'saitama',
    'hiroshima',
    'sendai',
  ],
  BR: [
    'sao-paulo',
    'rio-de-janeiro',
    'brasilia',
    'salvador',
    'fortaleza',
    'belo-horizonte',
    'curitiba',
    'recife',
    'porto-alegre',
    'manaus',
  ],
  AR: ['buenos-aires', 'cordoba', 'salta', 'rosario'],
  AT: [
    'graz',
    'innsbruck',
    'linz',
    'salzburg',
    'theresienfeld',
    'vienna',
    'wiener-neustadt',
  ],
  BE: ['antwerp', 'brussels', 'ghent', 'leuven'],
  DK: ['aalborg', 'aarhus', 'copenhagen', 'esbjerg'],
  FI: ['espoo', 'helsinki', 'oulu', 'tampere', 'turku', 'vaasa', 'vantaa'],
  NO: ['bergen', 'oslo', 'trondheim'],
  SA: ['dammam', 'jeddah', 'riyadh'],
  MX: ['mexico-city', 'tijuana', 'leon', 'guadalajara'],
  TH: ['bangkok', 'chiang-mai', 'pattaya-city', 'phuket'],
  PL: ['krakow', 'poznan', 'gdansk', 'lodz', 'warsaw', 'wroclaw'],
  GR: ['athens', 'larissa', 'thessaloniki'],
  HR: ['dubrovnik', 'osijek', 'rijeka', 'split', 'zadar', 'zagreb'],
  MY: [
    'penang',
    'george-town',
    'johor-bahru',
    'kuala-lumpur',
    'ipoh',
    'selangor',
    'subang-jaya',
    'kota-kinabalu',
  ],
};

export const isTierOneOrTwoCity = (countryCode, citySlug) => {
  if (!countryCode || !citySlug) {
    return false;
  }

  const upperCountryCode = countryCode.toUpperCase();

  // Any city in a tier 1 country is treated as tier 1
  if (TIER_ONE_COUNTRIES.includes(upperCountryCode)) {
    return true;
  }

  const tierTwoCitiesForCountry = TIER_TWO_CITIES[upperCountryCode];

  if (!tierTwoCitiesForCountry) {
    return false;
  }

  return tierTwoCitiesForCountry.includes(citySlug);
};
